import FlightSegments from './FlightSegments'

export default FlightSegments